import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import PropTypes from 'prop-types'

class Title4 extends React.Component {
  static propTypes = {
    pageNumber: PropTypes.string,
    children: PropTypes.node.isRequired,
  }
  render() {
    const { pageNumber, children } = this.props;

    return (
      <div className={s.root}>
        <div className={s.titleWrapper} contentEditable>
          <div className={s.pageNumber}>{pageNumber}</div>
          <div className={s.title}>{children}</div>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Title4);


// WEBPACK FOOTER //
// src/routes/visualChart/components/Titles/Title4/index.js